import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatRoleName } from 'utils/formatters';
import ResetPasswordIcon from 'components/atoms/icons/resetPasswordIcon';

const AgencyDoctorRow = ({ data, selectEmail }) => (
  <tr>
    <td data-label="Full Name">
      <div className="adminPanel__row">
        <Link
          data-cy="admin-panel__agency-user-link"
          to={`/admin/agent/${data.guid}`}
        >
          <strong>{`${data.title} ${data.firstName} ${data.lastName}`}</strong>
        </Link>
      </div>
    </td>
    <td data-label="Role">
      <div className="adminPanel__row">
        {data.roles
          .split(', ')
          .map((name) => formatRoleName(name))
          .join(', ')}
      </div>
    </td>
    <td data-label="Agency">
      <div className="adminPanel__row adminPanel__row--scroll">
        {data.agencies.join(', ')}
      </div>
    </td>
    <td data-label="Email">
      <div className="adminPanel__row">{data.email}</div>
    </td>
    <td data-label="Reset Email">
      <div className="button-wrapper">
        <button
          className="adminPanel__row resend-button"
          onClick={() => {
            selectEmail(data.email);
          }}
        >
          <ResetPasswordIcon />
        </button>
      </div>
    </td>
    <td data-label="Status">
      <div className="adminPanel__row adminPanel__row--status">
        {data.status
          ? data.status.charAt(0).toUpperCase() + data.status.slice(1)
          : 'Active'}
      </div>
    </td>
  </tr>
);

AgencyDoctorRow.propTypes = {
  data: PropTypes.shape().isRequired,
  selectEmail: PropTypes.func.isRequired,
};

export default AgencyDoctorRow;
